import React, { useMemo } from 'react';
import { VegaEmbed } from 'react-vega';
import { expressionInterpreter } from 'vega-interpreter';
import { TopLevelSpec } from 'vega-lite';
import './styles.css';

import useAPI from '@/hooks/useAPI';
import MetricRepository from '@/repositories/MetricsRepository';

import type { Props } from './types';

const MeasureChart = ({ person, measureKey }: Props) => {
  const metricRepository = MetricRepository();

  const {
    data: personMeasureResponse,
    isError: personMeasureError,
    isPending: personMeasurePending
  } = useAPI({
    queryKey: ['getpersonMeasure', person.id, measureKey],
    queryFn: async () => {
      return await metricRepository.measure(person.id, measureKey);
    }
  });

  const spec: TopLevelSpec = useMemo(() => {
    return {
      width: 'container',
      height: 200,
      padding: { top: 10, left: 30, right: 10, bottom: 30 },
      data: {
        name: 'table',
        values: (personMeasureResponse?.data?.timeseries || []).map((r) => ({
          x: r[0],
          y: r[1]
        }))
      },
      mark: {
        type: 'line',
        tooltip: true,
        point: true
      },
      encoding: {
        x: { field: 'x', type: 'temporal', title: 'Time' },
        y: { field: 'y', type: 'quantitative', title: 'Value' }
      }
    };
  }, [personMeasureResponse]);

  return (
    <div className="w-full">
      {personMeasurePending && <p>Loading...</p>}
      {personMeasureError && <p>Failed to load measure</p>}
      {personMeasureResponse && (
        <VegaEmbed
          spec={spec}
          className="w-full"
          options={{ ast: true, expr: expressionInterpreter }}
        />
      )}
    </div>
  );
};

export default React.memo(MeasureChart);
